import * as React from 'react'
import { Column } from '../types'

interface DateInputProps {
  column: Column
  value: string | number | string[] | number[] | null
  onChange: (value: string) => void
  fieldId: string
}

export default function DateInput({
  column,
  value,
  onChange,
  fieldId,
}: DateInputProps) {
  return (
    <input
      id={fieldId}
      type="date"
      className="form-control"
      value={String(value ?? '')}
      onChange={(e) => onChange(e.target.value)}
      required={column.required}
    />
  )
}
